import { render, staticRenderFns } from "./PupilDashboard.vue?vue&type=template&id=244963dc"
import script from "./PupilDashboard.vue?vue&type=script&lang=js"
export * from "./PupilDashboard.vue?vue&type=script&lang=js"
import style0 from "./PupilDashboard.vue?vue&type=style&index=0&id=244963dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports